<template>
    <div>
        <!-- TEXT TO  -->
        <!-- <div v-if="cardId === 1">
        </div> -->

        <!-- TEXT TO KC ROSSI COURSES and COSMETHICALLY JOURNAL and Joy's videos -->
        <!-- cardId 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17 -->
        <div v-if="cardId >= 3">
          <p>Reviews can help others when they struggle to find the right solution. This information is vital for good judgment when there are so many options but not as many solutions.</p>

          <p>This is really easy to do, and it will not take much time, but it does have a strong impact. Please share the best thing you like about receiving these special extras and how the Dropsmart center area helped you out in the comment section below.</p>
                
          <p>Thank you.</p>
        </div>

        
    </div>
</template>

<script>
export default {
  name: "FreeTextRightModal",
  mounted() {
    this.cardId = parseInt(this.$route.query.id)
  },
  data() {
    return {
        cardId: 0,
    }
  }
}
</script>
